/* v8 ignore start */
/**
 * DO NOT ADD TO THIS FILE
 *
 * This is a bog-standard React entry point. Userland code should be added to `./App.jsx`.
 */

import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

/**
 * use MSW responses instead of connecting to QA
 *
 * @returns {Promise<void>} - resolves when the worker is started
 */
async function enableMocking() {
  if (
    !(
      process.env.NODE_ENV === 'development' &&
      import.meta.env.UF_USE_MSW === 'true'
    )
  ) {
    return;
  }
  const { worker } = await import('./browser-mock');

  return worker.start();
}

enableMocking().then(() => {
  createRoot(document.querySelector('#root')).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
